import Listing from "../components/inventory/cart/cart";
import Nav from "../components/inventory/vendor/navbar";
const ListingPage = () => {
  return (
    <div>
      <Nav />
      <Listing />
    </div>
  );
};

export default ListingPage;